var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-top"},[_c('v-progress-linear',{attrs:{"active":_vm.$store.state.common.loader,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }